import { Location } from '@angular/common';
import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class LoginService {
	public constructor(private readonly location: Location) {}

	public login(): void {
		// If you have configured multiple OIDC providers, then, you can update this URL to /login.
		// It will show a Spring Security generated login page with links to configured OIDC providers.
		location.href = `${location.origin}${this.location.prepareExternalUrl(
			'/oauth2/authorization/oidc'
		)}`;
	}
}
